module.exports = __webpack_public_path__ + "static/media/5 6 tattoo leg tiger snarling realism fierce predatory.1280x1707.9f51e135.webp";